// extracted by mini-css-extract-plugin
module.exports = {"container":"Item_container__2JqIr","body":"Item_body__2vNEb","menu":"Item_menu__2vcIF","icon":"Item_icon__3uChf","details":"Item_details__2lj3u","name":"Item_name__2d1y_"};